import ChatRoom from './container';

export default ChatRoom;



// WEBPACK FOOTER //
// ./src/components/ChatRoom/index.js